export enum PoultryContextKeys {
  POULTRYNEXTREARING = 'poultrynextRearing',
  CYCLES_SELECTED_CYCLE_ID = 'cyclesSelectedCycleId',
  REFERENCE_VALUE_SHEET = 'referenceValueSheet',
  RVS_COLUMN_SETTINGS = 'columnSettings',
  RVS_SETTINGS = 'rvsSettings',
  STANDARD_REFERENCE_VALUE_SHEETS_COUNTRY = 'standardRefValSheetsCountry',
}
